import PropTypes from "prop-types"
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material"
import { map } from "lodash"

export default function CompareSectionStatus({ status, color, nameStyle, expanded, columnCount, rowCount }) {
  return <Accordion
    square
    className="renderers_compare-section single-row"
    expanded={expanded}
  >
    <AccordionSummary className="header">
      <div style={{ backgroundColor: color }} />
      <div className="name" style={nameStyle}>{status}</div>
      {map(Array(columnCount), (_, index) => <div key={index}>&nbsp;</div>)}
    </AccordionSummary>
    {expanded && <AccordionDetails className="body">
      {map(Array(rowCount), (_, index) => <div key={index}>
        <div style={{ backgroundColor: color }} />
        <div>&nbsp;</div>
        {map(Array(columnCount), (_, index) => <div key={index}>&nbsp;</div>)}
      </div>)}
    </AccordionDetails>}
  </Accordion>
}

CompareSectionStatus.propTypes = {
  status: PropTypes.string.isRequired,
  color: PropTypes.string,
  nameStyle: PropTypes.object,
  expanded: PropTypes.bool,
  columnCount: PropTypes.number.isRequired,
  rowCount: PropTypes.number,
}
